import getCreditCardType from "./getCreditCardType";
import errorTranslates from "./errorTranslates";

const regexName = /^[\p{L} ,.'-]+$/u; // /^[a-z ,.'-]+$/i;
// \p{L} — Matches any kind of letter from any language (Latin, Greek, Cyrillic, etc.)
// ,.'- — Allows common separators/punctuation in names
// u — Unicode flag to enable \p{L} support
const regexCVV = /^\d+$/;
const regexCVVwithLength = /^[0-9]{3,4}$/;
const regexExpiry = /^(0[1-9]|1[0-2])\/(2[4-9]|[3-9][0-9])$/;

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePhone = (phoneNumber) => {
  if (!phoneNumber) {
    return false
  }
  const phoneRegex = /^[\d+-]+$/;
  return phoneRegex.test(phoneNumber);
};

export const validateCVV = (cvv, final) => {
  const cvvPattern = final ? regexCVVwithLength : regexCVV;
  return cvvPattern.test(+cvv);
}

export const validateDisabledButton = (paymentSubmit, inputsToCheck, withValidation = false) => {
  if (!paymentSubmit) {
    return false
  }
  paymentSubmit.disabled = inputsToCheck.some(input => {
    if (!input) {
      return false
    }
    if (input.type === "checkbox") {
      return !input.checked
    }
    if (withValidation && inputHasError(input)) {
      return true
    }
    return !input.value || input.classList.contains("ui-input--error");
  });
  return paymentSubmit.disabled
}

/**
 * common function to request features
 * @param inputElement {node}
 * @param isBlur {boolean}
 * @param useValidation {boolean}
 * @returns {string}
 */
export const inputHasError = (inputElement, isBlur, useValidation = true) => {
  let hasError = "";
  const value = inputElement.value;
  if (inputElement.type === "checkbox") {
    return inputElement.checked ? "" : "errors.noValue"
  }
  if (!value || value === " ") {
    return "errors.noValue"
  }
  switch (inputElement.name) {
    case "payment[cardNumber]":
    case "payment_mini[cardNumber]":
    case "payment_short[cardNumber]": {
      if (!useValidation) {
        return hasError
      }
      hasError = getCreditCardType(value).text ? "" : "errors.incorrectCard";
      break;
    }
    case "payment_short[firstName]":
    case "payment_short[lastName]":
    case "payment[cardName]":
    case "payment_short[cardholderName]": {
      hasError = regexName.test(value) ? "" : "errors.incorrectName";
      break;
    }
    case "payment[cardExpire]":
    case "payment_mini[cardExpire]":
    case "payment_short[cardExpire]": {
      if (!useValidation && !isBlur) {
        return hasError
      }
      hasError = regexExpiry.test(value) ? "" : "errors.incorrectExpiry";
      break;
    }
    case "payment[cardSecurityCode]":
    case "payment_mini[cardSecurityCode]":
    case "payment_short[cardSecurityCode]": {
      if (!useValidation) {
        return hasError
      }
      hasError = validateCVV(value, isBlur) ? "" : "errors.incorrectCvv";
      break;
    }
    case "unsubscribe[email]":
    case "payment[email]":
    case "payment_short[email]": {
      if (!useValidation) {
        return hasError
      }
      hasError = validateEmail(value) ? "" : "errors.incorrectEmail";
      break;
    }
    case "payment[phone]":
    case "payment_short[phone]": {
      hasError = validatePhone(value) ? "" : "errors.incorrectPhone";
      break;
    }
    default:
      break;
  }
  return hasError
}

export function setInputError(input, error) {
  if (!input.errorSpan) {
    input.errorSpan = document.createElement("span");
    input.errorSpan.classList.add("ui-error");
    input.parentElement.appendChild(input.errorSpan);
  }
  input.errorSpan.innerText = error ? errorTranslates[error] || error : "";
  input.errorSpan.style.display = error ? "" : "none";
}

export function addSubmitLoader(paymentSubmit) {
  if (!paymentSubmit) {
    return
  }
  const {width, height} = paymentSubmit.getBoundingClientRect();
  const loaderIcon = document.createElement("div");
  paymentSubmit.value = "";
  paymentSubmit.classList.add("disabled");
  paymentSubmit.parentElement.classList.add("relative");
  loaderIcon.classList.add("flex", "ui-form__submit-loader");
  loaderIcon.style.cssText = `width:${width}px; height:${height}px;opacity: 0.6;`;
  loaderIcon.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
      <g>
        <path d="M1.875 16C1.875 8.21144 8.21144 1.875 16 1.875C19.1038 1.875 22.0799 2.88281 24.5243 4.73681L22.8375 5.00394C22.3261 5.08494 21.9772 5.56512 22.0582 6.07656C22.1313 6.53831 22.5299 6.86756 22.983 6.86756C23.0317 6.86756 23.0811 6.86375 23.1308 6.85588L26.7974 6.27513C27.3088 6.19413 27.6577 5.71394 27.5767 5.2025L26.996 1.53587C26.915 1.02444 26.4349 0.675875 25.9234 0.756562C25.412 0.837562 25.0631 1.31775 25.1441 1.82919L25.3296 3.00087C22.6241 1.05456 19.3789 0 16 0C11.7262 0 7.70831 1.66425 4.68625 4.68625C1.66431 7.70831 0 11.7262 0 16C0 18.7131 0.691688 21.3939 2.00038 23.7524C2.17163 24.0611 2.49131 24.2353 2.821 24.2353C2.97487 24.2353 3.13088 24.1973 3.275 24.1173C3.72775 23.8661 3.89112 23.2954 3.63987 22.8427C2.48531 20.7617 1.875 18.3956 1.875 16Z"/>
        <path d="M29.9621 8.18295C29.7088 7.73138 29.1373 7.57057 28.6859 7.82401C28.2343 8.07732 28.0736 8.6487 28.3269 9.10026C29.5023 11.1957 30.1236 13.5816 30.1236 16C30.1236 23.7886 23.7872 30.125 15.9986 30.125C12.895 30.125 9.91877 29.1172 7.4744 27.2632L9.16109 26.9961C9.67246 26.9151 10.0214 26.4349 9.9404 25.9234C9.8594 25.4121 9.37934 25.0632 8.86777 25.1441L5.20115 25.7249C4.68977 25.8059 4.34084 26.2861 4.42184 26.7975L5.00259 30.4641C5.07571 30.9259 5.47427 31.2551 5.9274 31.2551C5.97615 31.2551 6.02552 31.2513 6.07521 31.2434C6.58659 31.1624 6.93552 30.6822 6.85452 30.1708L6.66896 28.9991C9.37459 30.9454 12.62 32 15.9986 32C20.2724 32 24.2903 30.3358 27.3124 27.3138C30.3343 24.2917 31.9986 20.2738 31.9986 16C31.9986 13.2611 31.2945 10.5579 29.9621 8.18295Z"/>
      </g>
    </svg>
  `;
  paymentSubmit.parentElement.appendChild(loaderIcon);
}
